import { useEffect, useState } from 'react'
import {
  buildCartDate,
  getStoreName,
  getStoreAddressOrName
} from 'shop/components/NavBar/utils'
import { formatFulfillmentWindow } from 'shop/utils/common'
import { useShop } from '../useGlobalContext'
import { useConsumerCart } from '../useConsumerCart'

export interface NavDetails {
  logo: string
  store: string
  date: string
  time: string
  address: string
  partnerId: string
}

export const useNavBar = () => {
  const { config, partner } = useShop()
  const { partnerId } = config
  const { cart, cartLoading } = useConsumerCart()

  const logoUrl =
    partner?.content.images.logos.alternative?.original ||
    partner?.content.images.logos.primary?.original ||
    ''

  const [navDetails, setNavDetails] = useState({
    logo: logoUrl,
    store: '...',
    date: '...',
    time: '...',
    address: '...',
    partnerId: partnerId
  })

  /** Fulfillment Line created for non order confirmation page navbars */
  const createFulfillmentLine = () => {
    if (!cart) return '...'
    const orderType = cart?.fulfillment.orderType
    const window = cart?.fulfillment.window
    return orderType === 'ASAP' ? 'ASAP' : formatFulfillmentWindow(window)
  }

  const getNavDetails = () => ({
    logo: logoUrl,
    store: getStoreName(cart),
    date: buildCartDate(cart?.fulfillment.window.from),
    time: createFulfillmentLine(),
    address: getStoreAddressOrName(cart),
    partnerId: partnerId
  })

  useEffect(() => {
    if (cartLoading || !cart) return
    setNavDetails(getNavDetails())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart, cartLoading])

  return {
    navDetails,
    logoUrl
  }
}
